<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //breadcrumbs -->
            <!-- //contents_head -->

            <!-- detail_f -->
            <table class="create_table">
                <colgroup>
                    <col width="13.5%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>{{ $t('FIELD.GLOBAL.SUBJECT') }}<em class="txt_mandatory">*</em></th>
                        <td>
                            <span class="clearable w100">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder="Subject"
                                    maxlength="90"
                                    v-model="notice.title"
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.NOTICE.TARGET') }}
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <fieldset class="ui_table">
                                <span class="radio_item">
                                    <label class="radiobox-wrap" v-if="false">
                                        <input
                                            type="radio"
                                            name="rdo1"
                                            value="G"
                                            v-model="notice.distTarget"
                                        />
                                        <i class="radio-icon"></i>
                                        <em>{{ $t('FIELD.GLOBAL.GLOBAL') }}</em>
                                    </label>
                                    <label class="radiobox-wrap">
                                        <input
                                            type="radio"
                                            name="rdo1"
                                            value="S"
                                            v-model="notice.distTarget"
                                        />
                                        <i class="radio-icon"></i>
                                        <em>{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}</em>
                                    </label>
                                </span>

                                <span class="global_item">
                                    <fragment
                                        v-if="notice.distTarget === 'S' && selectedSubsidiaryList.length > 0"
                                    >
                                        <em name="selectSubsidiary" class="tooltip_box">
                                            (
                                            {{ selectedSubsidiaryList.length }}
                                            <template
                                                v-if="selectedSubsidiaryList.length > 1"
                                            >Subsidiaries</template>
                                            <template v-else>Subsidiary</template>
                                            )
                                            <i
                                                class="tooltip"
                                            >{{ selectedSubsidiaryList.join(', ') }}</i>
                                        </em>
                                    </fragment>
                                    <a
                                        v-if="notice.distTarget === 'S'"
                                        href="javascript:"
                                        class="ico_write_global"
                                        @click="globalTargetPop"
                                    >
                                        <span class="sr_only">{{ $t('BUTTON.KNOWLEDGE.GLOBALEDIT') }}</span>
                                    </a>
                                </span>
                            </fieldset>
                        </td>
                    </tr>
                    <tr>
                        <th>Popup
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span class="radio_item">
                                <label class="radiobox-wrap">
                                    <input
                                        type="radio"
                                        name="rdo2"
                                        value="Y"
                                        v-model="notice.popupYN"
                                    />
                                    <i class="radio-icon"></i>
                                    <em>{{ $t('FIELD.GLOBAL.YES') }}</em>
                                </label>
                                <label class="radiobox-wrap">
                                    <input
                                        type="radio"
                                        name="rdo2"
                                        value="N"
                                        v-model="notice.popupYN"
                                    />
                                    <i class="radio-icon"></i>
                                    <em>{{ $t('FIELD.GLOBAL.NO') }}</em>
                                </label>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Period
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td data-input-type="date">
                            <fieldset class="ui_fieldset">
                                <label class="date-wrap">
                                    <input
                                        id="fromDate"
                                        type="text"
                                        class="date_input w100"
                                        maxlength="10"
                                        placeholder="From Date"
                                        readonly
                                    />
                                    <a href="javascript:" class="in_btn" id="icoFromDate">
                                        <i class="ico_date"></i>
                                        <span class="sr_only">Open Calendar</span>
                                    </a>
                                </label>
                                <div id="from-picker-container" />
                                <em class="txt_space"></em>
                                <label class="date-wrap">
                                    <input
                                        id="toDate"
                                        type="text"
                                        class="date_input w100"
                                        maxlength="10"
                                        placeholder="To Date"
                                        readonly
                                    />
                                    <a href="javascript:" class="in_btn" id="icoToDate">
                                        <i class="ico_date"></i>
                                        <span class="sr_only">Open Calendar</span>
                                    </a>
                                </label>
                                <div id="to-picker-container" style="margin-top: -1px;" />
                            </fieldset>
                        </td>
                    </tr>

                    <tr>
                        <th>
                            {{ $t('FIELD.GLOBAL.DESCRIPTION') }}
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <cross-editor
                                v-if="!isLoading"
                                class="text_textarea w100"
                                editorId="noticeEditor"
                                :editorData="notice.description"
                                :key="notice.description"
                            />
                            <!-- 
                            <cross-editor-viewer
                                v-else-if="!isLoading"
                                :editorId="getEditorId"
                                :editorData="notice.description"
                            /> -->
                        </td>
                    </tr>

                    <tr v-if="!isLoading">
                        <th>{{ $t('FIELD.GLOBAL.ATTACHMENT') }}</th>
                        <td>
                            <innorix-upload
                                id="modify"
                                name="modify"
                                uploadId="modify"
                                serviceType="common"
                                :onlyUpload="false"
                                :attachList="fileList"
                                @files="setAttachFiles"
                            />
                        </td>
                    </tr>

                </tbody>
            </table>
            <!-- //detail -->
            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <a href="javascript:" class="btn_white" title @click="onListClick">{{$t('BUTTON.GLOBAL.LIST')}}</a>
                <div class="btn_right">
                    <a href="javascript:" class="btn_white" title @click="onDeleteClick">{{$t('BUTTON.GLOBAL.DELETE')}}</a>
                    <a href="javascript:" class="btn_blue" title @click="onModifyClick">{{$t('BUTTON.GLOBAL.SAVE')}}</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import { mapGetters } from 'vuex';

import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import moment from 'moment';

import DatePicker from '~c/DatePicker';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import api from '@/service';
import store from '@/vuex/store';
import SDLLocale from '@/mixin/SDLLocale';

import { SDLUtil, DateUtil, StringUtil, } from '@/utils';
import { EventBus } from '@/utils/EventBus';

import CrossEditor from '~c/CrossEditor';
import InnorixUpload from '~c/InnorixUpload';

import KnowledgeTargetPopup from '~vb/knowledge/popup/KnowledgeTargetPopup';

export default {
    name: 'noticeModify',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'cross-editor': CrossEditor,
        'innorix-upload': InnorixUpload,
    }, 
    props: {
        seq: {
            type: String | Number,
            reqruied: true,
        },
    },
    computed: {
        getGuid() {
            if (SDLUtil.isNull(this.guid)) {
                this.guid = StringUtil.guid();
            }
            return this.guid;
        },
        // getEditorId() {
        //     if (SDLUtil.isNull(this.editorId)) {
        //         this.editorId = 'ce_' + this.getGuid;
        //     }
        //     return this.editorId;
        // },
        getUploadId() {
            if (SDLUtil.isNull(this.uploadId)) {
                this.uploadId = 'inno_' + this.getGuid;
            }
            return this.uploadId;
        },
        getCompanyName() {
            return JSON.parse(localStorage.getItem('loginUser')).companyName;
        },
    },
    data() {
        return {
            ...mapGetters({
                locale: 'getLocale',
                getCorpCode: 'getCorpCd',
                getRhqCode: 'getLoginRhq',
            }),

            pageTitle: 'Notice',

            isLoading: true,

            selectedSubsidiaryList: [],

            notice: {
                title: '',
                distTarget: 'S', // G - Global (All subs), S - Only Selected Subs
                description: '',
                attachFiles: [],
                popupYN: 'N',
                status: 'N', // N - Normal; I - Important
                startDate: '',
                endDate: '',
            },

            guid: '', // �엫�쓽�쓽 guid
            editorId: 'editorId', // CE id
            uploadId: 'innorix', // Innorix id
            onlyUpload: false, // Innorix upload only check

            fileList: [],

            attachFileSeq: [], // Attach files
            delAttachFiles: [], // Delete attach files
            isRemove: false, // Attach remove flag

            rangePicker: null,

            notice: {
                title: '',
                distTarget: 'S', // S, G
                description: '',
                attachFiles: [],
                popupYN: 'N',
                startDate: '',
                endDate: '',
                searchToAddDt: '',
                searchFromAddDt: '',
            },
        };
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            // this.notice.startDate = DatePicker.create('from-picker-container', 'fromDate', 'icoFromDate');
            // this.notice.endDate = DatePicker.create('to-picker-container', 'toDate', 'icoToDate');

            SDLUtil.showLoadingBar(true);
            this.fetchData(this.seq)
                .then(data => {
                    this.setData(data.result);

                    this.fileList = data.attachFiles
                        .map(item => {
                            // item.ENC_ATTCH_FILE_SEQ = item.attachFileSeq;
                            item.ATTCH_FILE_SEQ = item.attachFileSeq;
                            item.FILE_NM = item.fileName;
                            item.FILE_SIZE = item.fileSize;
                            return item;
                        });

                    EventBus.$emit('innorix-reset-file-list', {
                        uploadId: 'modify',
                        fileList: this.fileList,
                    });

                    setTimeout(() => {
                        this.isLoading = false;
                        SDLUtil.showLoadingBar(false);
                    }, 500);
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                }); 
            });
    },
    methods: {

        fetchData(seq) {
            const path = '/basis/admin/other/notice/NoticeDetail.skp';
            const params = {
                noticeSeq: seq,
            };
            return SDLUtil.getRequest(path, params);
        },

        setData(data) {
            this.notice.title = data.title;

            this.notice.description = SDLUtil.stripHtml(data.content);
            this.selectedSubsidiaryList = data.subsidiaries.split(',').filter(item => item);
            this.notice.popupYN = data.popupYn;

            // this.notice.startDate.setDate(new Date(data.startDate));
            // this.notice.endDate.setDate(new Date(data.endDate));

            const now = new Date();

            const format = localStorage.getItem('mDateFormat') || 'MM.DD.YYYY'
            this.rangePicker = DatePicker.createRangeWithOpener(
                'from-picker-container', 'fromDate', 'icoFromDate',
                'to-picker-container', 'toDate', 'icoToDate',
                { type: 'date', locale: 'en', showToday: true },
                moment(data.startDate, 'MM.DD.YYYY').toDate(),
                moment(data.endDate, 'MM.DD.YYYY').toDate(),
                new Date(now.getFullYear() - 10, now.getMonth(), now.getDate()),
                new Date(now.getFullYear() + 10, now.getMonth(), now.getDate()),
            );
        },

        globalTargetPop() {
            SDLUtil.show(
                KnowledgeTargetPopup,
                {
                    // class: 'md_size',
                    selTargetList: this.selectedSubsidiaryList,
                    rtnFunc: (list = []) => {
                        // Subsidiary Target popup 
                        this.selectedSubsidiaryList = list.sort();
                    },
                },
                { width: '100%', height: 'auto' },
            );
        },

        setAttachFiles(val) {
            console.info('[INFO] InnorixUpload.vue -> NoticeModify.vue / files : ', val);
            this.attachFileSeq = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || false;
        },

        onListClick(event) {
            // TODO check if the user really wants to go back
            // if (this.notice.subject.length > 0) {

            // }
            // if (this.notice.content)
            // SDLUtil.confirm({
            //     title: '',
            //     msg: 'Are you '
            // })
            this.goToList();
        },
        goToList() {
            this.$router.push({name: 'NoticeManagementList'});

        },

        onModifyClick() {
            this.modify();
        },

        onDeleteClick() {
            SDLUtil.confirm({
                title: 'Confirm',
                msg: 'Want to delete?',
                okLbl: 'BUTTON.GLOBAL.REMOVE',
                onOkEvt: () => {
                    this.delete();
                },
            });
        },

        async modify() {
            if (!this.validateInput()) return;
            const params = this.prepParams();

            SDLUtil.showLoadingBar(true);
            const data = await this.postModify(params);
            SDLUtil.showLoadingBar(false);
            if (data === false) return;
            this.onModifySuccess();
        },

        async delete() {
            const params = {
                noticeSeq: this.seq,
            };
            SDLUtil.showLoadingBar(true);
            const data = await this.postDelete(params);
            SDLUtil.showLoadingBar(false);
            if (data === false) return;
            this.onDeleteSuccess();
        },

        validateInput() {
            // title: '',
            // distTarget: 'S', // S, G
            // description: '',
            // attachFiles: [],
            // popupYN: 'N',
            // startDate: '',
            // endDate: '',

            const CEblankTxt = '<p><br></p>';
            const content = window.noticeEditor.GetBodyValue();
            if (content === CEblankTxt) {
                content = '';
            }

            let errorMessages = [];

            if (this.notice.title.trim().length === 0) {
                errorMessages.push(this.$t('MESSAGE.KNOWLEDGE.REQUIRE.SUBJECT'));
                // errorMessages.push('Subject is required.');
            }

            if (this.notice.title.length < 10) {
                errorMessages.push('Subject needs to be 10 or more characters long.');
            }

            if (this.notice.distTarget === 'S') {
                if (this.selectedSubsidiaryList.length === 0) {
                    errorMessages.push('Subsidiary is required.');
                }
            }

            if (this.notice.popupYN === 'Y') {
                Vue.$log.info("▶ NoticeModify.vue startDate Get DATE", this.notice.startDate.getDate());  
                if (this.notice.startDate.getDate() == null) {
                    errorMessages.push('Popup From date is required.');
                }
                if (this.notice.endDate.getDate() == null) {
                    errorMessages.push('Popup To date is required.');
                }
            }

            if (content.trim().length <= 50) {
                errorMessages.push(`Description must be longer than 50 chars. (${content.trim().length} chars now)`);
            }

            if (errorMessages.length > 0) {
                const title = 'Invalid Input';
                SDLUtil.alert({
                    title,
                    msg: errorMessages.map(msg => `- ${msg}`).join('<br>'),
                });
                return false;
            }

            return true;
        },

        prepParams() {
            function stripHtml(html) {
                const tmp = document.createElement('div');
                tmp.innerHTML = html;
                return tmp.textContent || tmp.innerText || '';
            }

            // const content = stripHtml(window.noticeEditor.GetBodyValue());

            const content = window.noticeEditor.GetBodyValue();
            
            const format = moment().toMomentFormatString(localStorage.getItem('mDateFormat') || 'MM.DD.YYYY');

            const startDate = this.rangePicker.getStartDate()
                ? moment(this.rangePicker.getStartDate()).formatWithJDF(format)
                : '';
            const endDate = this.rangePicker.getEndDate()
                ? moment(this.rangePicker.getEndDate()).formatWithJDF(format)
                : '';

            // const params = this.notice;
            const params = {
                noticeSeq: this.seq,
                subsidiaries: this.selectedSubsidiaryList.map(item => `${item},`).join(''),
                title: this.notice.title,
                content: content,
                popupYn: this.notice.popupYN,
                status: 'N', // N - Normal, I - Important
                // startDate: this.notice.startDate || '1945-08-15',
                // endDate: this.notice.endDate || '2045-08-15',
                startDate: startDate || '',
                endDate: endDate || '',
                attachFileSeq: this.attachFileSeq.map(item => item.attachFileSeq),
            };
            return params;
        },

        postModify(formData) {
            Vue.$log.info('▶ NoticeModify.vue POST DATA ===>> ', formData);
            const path = '/basis/admin/other/notice/NoticeUpdate.skp';
            return SDLUtil.postForm(path, formData);
        },

        postDelete(formData) {
            Vue.$log.info('▶ NoticeModify.vue POST DATA ===>> ', formData);
            const path = '/basis/admin/other/notice/NoticeDelete.skp';
            return SDLUtil.postForm(path, formData);
        },

        onModifySuccess() {
            SDLUtil.alert({
                msg: 'MESSAGE.SUCCESS.SAVED',
                onOkEvt: () => {
                    this.goToList();
                },
            });

        },
        onDeleteSuccess() {
            SDLUtil.alert({
                msg: 'MESSAGE.SUCCESS.DELETED',
                onOkEvt: () => {
                    this.goToList();
                },
            });

        },

    },
};
</script>

<style>
.zindex9999 {
    z-index: 9999;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/other/NoticeModify.vue